module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/high-volume-high-roof-van.d18ca0ca.svg";